<div class="ai-resources-container">
    <app-video-link videoLink="ai_dalle" class="video-link-position"></app-video-link>

    <div class="content-wrapper">

        <div *ngIf="showMediaTypeSelector" class="media-type-selector">
            <mat-icon class="selector-icon">auto_fix_high</mat-icon>
            <span class="selector-label">{{ 'ai.selectMediaType' | transloco }}</span>
            <mat-radio-group (change)="onSelection($event)" [(ngModel)]="selectedMediaType"
                             aria-label="AI media type" class="radio-group">
                <mat-radio-button value="image">{{ 'ai.image' | transloco }}</mat-radio-button>
                <mat-radio-button value="video" [disabled]="true">{{ 'ai.video' | transloco }}</mat-radio-button>
            </mat-radio-group>
        </div>

        <div *ngIf="selectedMediaType === 'image'" class="resolution-selector">
            <mat-icon class="selector-icon">photo_size_select_large</mat-icon>
            <span class="selector-label">{{ 'ai.imageResolution' | transloco }}</span>
            <mat-radio-group [(ngModel)]="selectedResolution" aria-label="Image resolution" class="radio-group">
                <mat-radio-button value="low">
                    {{ 'ai.lowResolution' | transloco }}
                    <span class="resolution-hint">({{ 'ai.faster' | transloco }})</span>
                </mat-radio-button>
                <mat-radio-button value="high">
                    {{ 'ai.highResolution' | transloco }}
                    <span class="resolution-hint">({{ 'ai.longerGeneration' | transloco }})</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <mat-form-field class="prompt-field" appearance="outline">
            <mat-label>
                <mat-icon class="label-icon">edit_note</mat-icon>
                {{
                    selectedMediaType === 'image'
                        ? ('ai.enterPromptImage' | transloco)
                        : ('ai.enterPromptVideo' | transloco)
                }}
            </mat-label>
            <textarea matInput rows="4"
                      inputrestriction="basic1"
                      [(ngModel)]="filter"
                      spellcheck="true"
                      class="prompt-textarea"></textarea>
            <button mat-icon-button matSuffix aria-label="Clear" (click)="clearFilterSelection()" class="clear-btn">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>

        <div class="actions-section">
            <button
                    mat-raised-button
                    color="primary"
                    class="generate-button"
                    [disabled]="loadingImages || filter.length < 5"
                    (click)="getImages()">
                <mat-icon *ngIf="!loadingImages">auto_awesome</mat-icon>
                <span *ngIf="!loadingImages">{{ 'general.generateContent' | transloco }}</span>
                <app-loading *ngIf="loadingImages" [size]="'20px'"></app-loading>
            </button>
            <div class="usage-stats">
                <mat-icon class="stats-icon">analytics</mat-icon>
                <span>{{ callsToday }} / {{ totalCalls }} {{ 'ai.callsToday' | transloco }}</span>
            </div>
        </div>

        <div *ngIf="loadingImages" class="loading-section">
            <ngx-skeleton-loader
                    animation="progress-dark"
                    class="preview-loader"
                    [theme]="{height: '300px', width: '400px', borderRadius: '12px', 'background-color': 'var(--background-color1)'}">
            </ngx-skeleton-loader>
            <div flashlightText class="loading-text-primary">
                {{ 'general.severalMinutes' | transloco }}
            </div>
            <div class="loading-text-secondary">
                {{ 'general.stayPage' | transloco }}
            </div>
        </div>
    </div>

    <div *ngIf="selectedMediaType==='video' && videoUploadReady" class="video-result-container">
        <div class="video-wrapper">
            <video loop
                   controls
                   autoplay
                   [src]="safeVideoUrl"
                   preload="metadata"
                   class="generated-video"></video>
            <button mat-fab class="upload-fab" matTooltip="{{'general.downloadToResources' | transloco}}"
               (click)="uploadVideoToResource()">
                <mat-icon>download</mat-icon>
            </button>
        </div>
    </div>

    <div *ngIf="selectedMediaType==='image' && aiImages.length > 0" class="image-result-container">
        <div *ngFor="let img of aiImages; trackBy: trackByName" class="ai-image-card">
            <ng-container *ngIf="!img.loading">
                <img [src]="img.base64" loading="lazy" class="generated-image">
                <div class="image-overlay">
                    <button mat-fab color="primary" class="upload-fab"
                       matTooltip="{{'general.downloadToResourcesImage' | transloco}}"
                       [disabled]="img.uploading"
                       (click)="uploadImageToResource(img)">
                        <mat-icon *ngIf="!img.uploading">download</mat-icon>
                        <app-loading *ngIf="img.uploading" [size]="'20px'"></app-loading>
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</div>
